export default {
      id: "kazakh_tourism-dark-usage",
      viewBox: "0 0 49 46",
      url: __webpack_public_path__ + "img/icons.cd84ca0f.svg#kazakh_tourism-dark",
      toString: function () {
        return this.url;
      }
    }